/* eslint-disable react-hooks/rules-of-hooks */
import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { Popup, TPopupComponent } from '../popup/popup.abstract';
import { TPopupDefaultActions } from '../popup/services/popup.service';
import { Box, Button, Stack, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

export class WarningsOnCreationPopup extends Popup<IWarningsOnCreationPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;

    this.Component = () => {
      const [params, setParams] = useState<
        Pick<IWarningsOnCreationPopup, 'content' | 'onConfirm' | 'width' | 'title'>
      >({});
      const { t } = useTranslation();
      useEffect(() => {
        stream.actionListener('open').subscribe((v) => setParams(v));
      }, []);
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          ...(params.width && {
            '& > div > div': { maxWidth: params.width, minWidth: params.width },
          }),
        }));
      }, [params.width]);

      return (
        <SWrapper stream={stream} popupTitle={params.title || t('order.create_order')}>
          <Box
            sx={{
              typography: 'body1',
            }}
          >
            {params.content || ''}
          </Box>
          <Stack
            direction='row'
            spacing={2}
            sx={{
              mt: 2,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={() => {
                params.onConfirm?.();
                stream.emit('close');
              }}
              variant='contained'
            >
              {t('common.proceed_anyway')}
            </Button>
          </Stack>
        </SWrapper>
      );
    };
  }
}

export interface IWarningsOnCreationPopup {
  action: 'confirm' | TPopupDefaultActions;
  content?: ReactNode;
  onConfirm?: () => void;
  width?: number;
  title?: string;
}
